export const wrapperInsideStyles = ({...props}) => {
  const {palette, size} = props.theme
  return `
        background: ${palette.common.white};
        box-shadow: ${size(0)}px ${size(0.25)}px ${size(0.5)}px ${size(
    0.125,
  )}px #00000010;
        max-width: ${size(21)}px;
        width: ${size(21)}px;
        height: ${size(10)}px;
        overflow: hidden;
        position: relative;
        border-radius: ${size(0.625)}px;
        [ap_type="label2"]{
          text-transform:uppercase;
        }
    `
}
export const swatchStyles = ({...props}) => {
  const {size, space} = props.theme
  return `
        display: flex;
        justify-content: center;
        align-items: center;
        padding: ${space(2)}px;
        width: 100%;
        height: 100%;
        border-radius: ${size(0.625)}px;
        border: ${size(0.125)}px solid #00000030;
    `
}

export const swatchLabelStyles = ({...props}) => {
  const {palette, space} = props.theme
  return `
         display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        flex-direction: column;
        line-height: 1.4em;
        text-align:center;
        word-break: break-word;
        margin: 0;
      
        
        &#high_emphasis_grey,
        &#someColorId,
        &#primary_blue,
        &#black,
        &#alert_red,
        &#medium_emphasis_grey,
        &#success_green,
        &#caution_orange,
        &#toast_green{
          color: ${palette.common.white};
        }

        &#background_red{
          color:${palette.error.dark};
        }
        
        >span:first-child{
          padding-right: ${space(1 / 2)}px;
          padding-left: ${space(1 / 2)}px;
        }
        >span:last-child{
          text-transform:uppercase;
        }
        
    `
}
